module.exports = __webpack_public_path__ + "img/avatar.35794838.png";